
import Vue from "vue";
import _ from "lodash";
import store from "../../store/shop";
import ShopAPI from "../../common/api/api_shop";
import { TranslateServiceBuilder } from "../../services/Translate/translateServiceBuilder";
import { CustomerCountType } from "../../model/entity/shopSetting";
import notificationMixin from "../../mixin/notification";

const translate = TranslateServiceBuilder.Instance()._;
const api = new ShopAPI();

Vue.directive('enhance-defaulot-value', {
    bind: (el) => {
        el.addEventListener('focus', () => {
            const value = el.value;
            if (value === 0) {
                el.value = '';
            }
        });
        el.addEventListener('blur', () => {
            const value = el.value;
            if (value === '') {
                el.value = 0;
            }
        });
    }
});

export default Vue.extend({
  components: {
    QTranslate: () => import("../../components/elements/QTranslate.vue"),
    QButton: () => import("../../components/elements/QButton.vue"),
  },
  mixins: [notificationMixin],
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false,
    },
    seatId: {
      required: true,
    },
  },
  data() {
    return {
      publish: {
        adult: 0,
        male: 0,
        female: 0,
        child: 0,
      },
      isOpenSuccessPopup: false,
      customerCountType: store.state.shopSetting.customer_count_type,
      customerCountTypes: CustomerCountType,
    };
  },
  mounted() {
    api.set_token(store.state.token);
  },
  watch: {
    isOpen() {
      this.resetForm();
    //   this.$refs.focus_first_publish_adult.focus();
    },
  },
  computed: {
    show() {
      return this.isOpen ? "checked" : "";
    },
    showSuccessPopup() {
      return this.isOpenSuccessPopup ? "checked" : "";
    },
    prefix() {
      return this.$route.params.prefix;
    },
    shoppix() {
      return this.$route.params.shoppix;
    },
    isInvalidInput(): boolean {
      const adult = Number.parseInt(this.publish.adult);
      const male = Number.parseInt(this.publish.male);
      const female = Number.parseInt(this.publish.female);
      const child = Number.parseInt(this.publish.child);
      const total = adult + male + female + child;
      if (_.isNaN(total) || adult < 0 || male < 0 || female < 0 || child < 0) {
        return true;
      }
      if (total === 0) {
        return true;
      }

      return false;
    }
  },
  methods: {
    closeSuccessPopup() {
      this.isOpenSuccessPopup = false;
    },
    resetForm() {
      this.publish = {
        adult: 0,
        male: 0,
        female: 0,
        child: 0,
      };
    },
    handleClickSubmit: function () {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      // this.submitItem();
      api
        .checkIn({
          seat_id: this.seatId,
          quantities: Number.parseInt((this.publish.child || 0)) + Number.parseInt(this.publish.adult || 0) + Number.parseInt(this.publish.male || 0) + Number.parseInt(this.publish.female || 0),
          quantity_adult: this.publish.adult || 0,
          quantity_male: this.publish.male || 0,
          quantity_female: this.publish.female || 0,
          quantity_child: this.publish.child || 0,
        })
        .then((response) => {
          if (response.data.status === "error") {
            this.showErrorNotification(response.data.message);
          } else {
            this.$emit("update");
            this.isOpenSuccessPopup = true;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    closeEditor: function () {
      this.isLoading = false;
      this.$emit("close");
    },
    isGender() {
      return this.customerCountType === this.customerCountTypes.GENDER;
    },
    isGenderAndChild() {
      return this.customerCountType === this.customerCountTypes.GENDER_AND_CHILD;
    },
  },
  filters: {},
});
